import * as React from "react";
import { Route, Switch } from "react-router";

import TagManager from "react-gtm-module";

import MapPage from "./components/pages/MapPage";
import SigninCallbackPage from "./components/pages/SigninCallbackPage";
import NotFoundPage from "./components/pages/NotFoundPage";

import "./custom.css"

const App = () => {

    TagManager.initialize({ gtmId: process.env.REACT_APP_GTM_ID });

    return (
        <Switch>
            <Route exact key="root" path="/" component={MapPage}/>
            <Route exact key="mapsByQuery" path="/maps/*" component={MapPage}/>
            <Route exact key="signinCallback" path="/signinCallback" component={SigninCallbackPage}/>
            <Route component={NotFoundPage}/>
        </Switch>
    );
};

export default App;